export default __webpack_public_path__ + "data/7107a17.countries.geo.json";